import { render } from "./ReviewFormComponent.vue?vue&type=template&id=50fdbd91&scoped=true"
import script from "./ReviewFormComponent.vue?vue&type=script&lang=js"
export * from "./ReviewFormComponent.vue?vue&type=script&lang=js"

import "./ReviewFormComponent.vue?vue&type=style&index=0&id=50fdbd91&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50fdbd91"]])

export default __exports__